import { render, staticRenderFns } from "./Issuance.vue?vue&type=template&id=8151871a&scoped=true"
import script from "./Issuance.vue?vue&type=script&lang=ts"
export * from "./Issuance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151871a",
  null
  
)

export default component.exports